import React from 'react'
import NetworkAssessmentSlider from '../main/ui/slider/NetworkAssessmentSlider'

const LiveNetworkAssessmentSlider = props => {
  const max = props.value?.max || props.maxValue
  const min = props.value?.min || props.minValue

  const maxInputFormElement = document.getElementById(props.maxInputId)
  const minInputFormElement = document.getElementById(props.minInputId)

  const [value, setValue] = React.useState({ min, max })

  const handleChange = updatedValues => {
    const { max: updatedMax, min: updatedMin } = updatedValues

    if (maxInputFormElement) {
      maxInputFormElement.value = updatedMax || props.maxValue
    }

    if (minInputFormElement) {
      minInputFormElement.value = updatedMin || props.minValue
    }

    setValue(updatedValues)
  }

  return (
    <NetworkAssessmentSlider
      {...props}
      value={value}
      participatesInAssessment={props.participatesInAssessment}
      label={props.label}
      onChange={handleChange}
    />
  )
}

export default LiveNetworkAssessmentSlider
